module.exports = __webpack_public_path__ + "img/40_69_012_420.921a1d3c.jpg";